// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.related-product-container {
  display: inline-flex;
  height: 100vh;
  width: 100vw;
  max-width: 310px;
  max-height: 470px;
  min-width: 150px;
  min-height: 275px;
  border-radius: 16px;
  box-shadow: 0px 0px 7px 1px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  position: relative;
}
.related-product-container .tag {
  position: absolute;
  top: 0;
  left: 12%;
  width: 53px;
  height: auto;
  border-radius: 0 !important;
}
.related-product-container .gift-radio {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 24px;
  height: 24px;
  color: var(--color-detached) !important;
}
.related-product-container .gift-radio .ant-radio-checked span::after {
  transform: scale(0.6);
  border-radius: 50px;
}
.related-product-container .price-content {
  position: absolute;
  bottom: 0px;
  padding: 16px;
}
.related-product-container .principal-content {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 16px;
  flex-direction: column;
}
.related-product-container .principal-content .carousel-container {
  width: 275px;
  height: 204px;
  margin-top: 20%;
  margin-bottom: 20px;
}
.related-product-container .principal-content .carousel-container .carousel-item {
  height: 100%;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  object-fit: cover;
}
.related-product-container .principal-content .carousel-container .carousel-item .carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
}
.related-product-container .principal-content .data-content .show-more-link {
  font-size: 14px;
  line-height: 20px;
  color: var(--color-detached);
  margin-top: 15px;
}
.related-product-container .principal-content .data-content .content-title {
  font-size: 14px;
  line-height: 18px !important;
  color: var(--color-neutral-dark-darker);
  font-weight: 600;
}
.related-product-container .product-title {
  margin-top: var(--spacing-small);
  font-size: var(--font-medium) !important;
  color: var(--color-neutral-dark-darker);
  line-height: var(--spacing-regular);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.related-product-container .select-qt-text {
  margin-top: var(--spacing-small);
  font-size: var(--font-small);
  color: var(--color-neutral-dark-darker);
  line-height: var(--spacing-regular);
  font-weight: 500;
}
.related-product-container .custom-input {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  border-radius: var(--border-radius-primary);
  width: 172px;
  min-height: 52px;
  margin-top: 8px;
}
.related-product-container .custom-input:focus {
  outline: none;
}
.related-product-container .number-input {
  flex: 2;
  border: none;
  text-align: center;
  padding: 5px;
  font-size: 16px;
  max-width: 90px;
  height: 75%;
  outline: none;
}
.related-product-container .number-input::-webkit-inner-spin-button,
.related-product-container .number-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.related-product-container button {
  flex: 1;
  background-color: #fff;
  border: none;
  cursor: pointer;
  outline: none;
  color: var(--color-neutral-light);
  display: flex;
  justify-content: center;
}
.related-product-container button .button-text {
  font-size: 24px;
  font-weight: 500;
  color: var(--color-detached);
}
.related-product-container .decrement {
  margin-left: 14px;
  border: 0;
}
.related-product-container .increment {
  margin-right: 14px;
  border: 0;
}
.related-product-container .unavailable-text {
  font-size: var(--font-big);
  color: var(--color-neutral-dark-darker);
  line-height: var(--spacing-regular);
  font-weight: 500;
}
.related-product-container .divider {
  border: 1px solid #DDDDDD;
  width: 309px;
  position: absolute;
  bottom: 68px;
}
.related-product-container.unavailable {
  filter: grayscale(100%);
  cursor: none;
  pointer-events: none;
}
.related-product-unavailable {
  color: var(--color-neutral-dark-lighter) !important;
}
.related-product-unavailable strong,
.related-product-unavailable .vert-paragraph {
  color: var(--color-neutral-dark-lighter) !important;
}
.related-product-unavailable-image {
  filter: grayscale(1);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Product/RelatedProductsCardStyles.less"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,+CAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AAZA;EAcQ,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AACR;AApBA;EAuBQ,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EAEA,uCAAA;AADR;AA5BA;EAiCgB,qBAAA;EACA,mBAAA;AAFhB;AAhCA;EAwCQ,kBAAA;EACA,WAAA;EACA,aAAA;AALR;AArCA;EA8CQ,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AANR;AA5CA;EAqDY,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AANZ;AAlDA;EA2DgB,YAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AANhB;AA1DA;EAmEoB,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AANpB;AAhEA;EA6EgB,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;AAVhB;AAtEA;EAoFgB,eAAA;EACA,4BAAA;EACA,uCAAA;EACA,gBAAA;AAXhB;AA5EA;EA6FQ,gCAAA;EACA,wCAAA;EACA,uCAAA;EACA,mCAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AAdR;AAvFA;EAyGQ,gCAAA;EACA,4BAAA;EACA,uCAAA;EACA,mCAAA;EACA,gBAAA;AAfR;AA9FA;EAiHQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,2CAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAhBR;AAxGA;EA4HQ,aAAA;AAjBR;AA3GA;EAgIQ,OAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;AAlBR;AArHA;;EA4IQ,wBAAA;EACA,SAAA;AAnBR;AA1HA;EAiJQ,OAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,iCAAA;EACA,aAAA;EACA,uBAAA;AApBR;AApIA;EA2JY,eAAA;EACA,gBAAA;EACA,4BAAA;AApBZ;AAzIA;EAkKQ,iBAAA;EACA,SAAA;AAtBR;AA7IA;EAuKQ,kBAAA;EACA,SAAA;AAvBR;AAjJA;EA4KQ,0BAAA;EACA,uCAAA;EACA,mCAAA;EACA,gBAAA;AAxBR;AAvJA;EAmLQ,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAzBR;AA6BA;EACI,uBAAA;EACA,YAAA;EACA,oBAAA;AA3BJ;AA8BA;EACI,mDAAA;AA5BJ;AA2BA;;EAKQ,mDAAA;AA5BR;AAgCA;EACI,oBAAA;AA9BJ","sourcesContent":[".related-product-container {\n    display: inline-flex;\n    height: 100vh;\n    width: 100vw;\n    max-width: 310px;\n    max-height: 470px;\n    min-width: 150px;\n    min-height: 275px;\n    border-radius: 16px;\n    box-shadow: 0px 0px 7px 1px rgba(0, 0, 0, 0.15);\n    box-sizing: border-box;\n    position: relative;\n\n    .tag {\n        position: absolute;\n        top: 0;\n        left: 12%;\n        width: 53px;\n        height: auto;\n        border-radius: 0 !important;\n    }\n\n    .gift-radio {\n        position: absolute;\n        top: 18px;\n        right: 18px;\n        width: 24px;\n        height: 24px;\n\n        color: var(--color-detached) !important;\n\n        .ant-radio-checked {\n            span::after {\n                transform: scale(0.6);\n                border-radius: 50px;\n            }\n        }\n    }\n\n    .price-content {\n        position: absolute;\n        bottom: 0px;\n        padding: 16px;\n    }\n\n    .principal-content {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        padding: 16px;\n        flex-direction: column;\n\n        .carousel-container {\n            width: 275px;\n            height: 204px;\n            margin-top: 20%;\n            margin-bottom: 20px;\n\n            .carousel-item {\n                height: 100%;\n                display: flex !important;\n                flex-direction: column;\n                justify-content: center;\n                align-items: center;\n                object-fit: cover;\n\n                .carousel-image {\n                    width: 100%;\n                    height: 100%;\n                    object-fit: cover;\n                    border-radius: 16px;\n                }\n            }\n        }\n\n        .data-content {\n            .show-more-link {\n                font-size: 14px;\n                line-height: 20px;\n                color: var(--color-detached);\n                margin-top: 15px;\n            }\n\n            .content-title {\n                font-size: 14px;\n                line-height: 18px !important;\n                color: var(--color-neutral-dark-darker);\n                font-weight: 600;\n            }\n        }\n    }\n\n    .product-title {\n        margin-top: var(--spacing-small);\n        font-size: var(--font-medium) !important;\n        color: var(--color-neutral-dark-darker);\n        line-height: var(--spacing-regular);\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .select-qt-text {\n        margin-top: var(--spacing-small);\n        font-size: var(--font-small);\n        color: var(--color-neutral-dark-darker);\n        line-height: var(--spacing-regular);\n        font-weight: 500;\n    }\n\n    .custom-input {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid #ccc;\n        border-radius: var(--border-radius-primary);\n        width: 172px;\n        min-height: 52px;\n        margin-top: 8px;\n    }\n\n    .custom-input:focus {\n        outline: none;\n    }\n\n    .number-input {\n        flex: 2;\n        border: none;\n        text-align: center;\n        padding: 5px;\n        font-size: 16px;\n        max-width: 90px;\n        height: 75%;\n        outline: none;\n    }\n\n    .number-input::-webkit-inner-spin-button,\n    .number-input::-webkit-outer-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    button {\n        flex: 1;\n        background-color: #fff;\n        border: none;\n        cursor: pointer;\n        outline: none;\n        color: var(--color-neutral-light);\n        display: flex;\n        justify-content: center;\n\n        .button-text {\n            font-size: 24px;\n            font-weight: 500;\n            color: var(--color-detached);\n        }\n    }\n\n    .decrement {\n        margin-left: 14px;\n        border: 0;\n    }\n\n    .increment {\n        margin-right: 14px;\n        border: 0;\n    }\n\n    .unavailable-text {\n        font-size: var(--font-big);\n        color: var(--color-neutral-dark-darker);\n        line-height: var(--spacing-regular);\n        font-weight: 500;\n    }\n\n    .divider {\n        border: 1px solid #DDDDDD;\n        width: 309px;\n        position: absolute;\n        bottom: 68px;\n    }\n}\n\n.related-product-container.unavailable {\n    filter: grayscale(100%);\n    cursor: none;\n    pointer-events: none;\n}\n\n.related-product-unavailable {\n    color: var(--color-neutral-dark-lighter) !important;\n\n    strong,\n    .vert-paragraph {\n        color: var(--color-neutral-dark-lighter) !important;\n    }\n}\n\n.related-product-unavailable-image {\n    filter: grayscale(1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
